import { render, staticRenderFns } from "./PermitList.vue?vue&type=template&id=664f5ca2&lang=pug&"
import script from "./PermitList.vue?vue&type=script&lang=js&"
export * from "./PermitList.vue?vue&type=script&lang=js&"
import style0 from "./PermitList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports